import { useState } from 'react';
import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategorySection from './components/CategorySection';
import CollectionsSection from './components/CollectionsSection';
import FeaturesSection from './components/FeaturesSection';
import LatestSection from './components/LatestSection';
import StatsSection from './components/StatsSection';
import GuideSection from './components/GuideSection';
import FaqSection from './components/FaqSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('');

  const handleSelectCategory = (id: string) => {
    setActiveCategory(id);
    if (id) {
      const el = document.getElementById('collections');
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <TrendingSection />
        <CategorySection activeCategory={activeCategory} onSelect={handleSelectCategory} />
        <CollectionsSection activeCategory={activeCategory} onSelectCategory={setActiveCategory} />
        <FeaturesSection />
        <LatestSection />
        <StatsSection />
        <GuideSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}